import { render, staticRenderFns } from "./ComponentTimeDecay.vue?vue&type=template&id=394f835a"
import script from "./ComponentTimeDecay.vue?vue&type=script&lang=js"
export * from "./ComponentTimeDecay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports